import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import calculatrice from "../../Assets/Projects/calculatrice.png";
import spotifapi from "../../Assets/Projects/spotifapi.png";
import boutique from "../../Assets/Projects/boutique.png";
import logo from "../../Assets/Projects/logo.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Mes <strong className="purple">Projets </strong>
        </h1>
        <p style={{ color: "white" }}>
        Voici quelques-uns de mes projets
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={spotifapi}
              isBlog={false}
              title="SpotifApi"
              description="SpotifApi est une application web de musique en ligne qui utilise l'API de Spotify pour permettre aux utilisateurs de rechercher et d'écouter de la musique directement depuis leur navigateur. L'application offre une interface utilisateur intuitive pour parcourir les playlists, les albums et les artistes. Les utilisateurs peuvent également créer des playlists personnalisées et les sauvegarder dans leur compte Spotify. Ce projet a été développé pour démontrer l'intégration d'une API tierce et la gestion des données en temps réel.

"
              ghLink="https://github.com/2Alexis/SpotifApi"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={boutique}
              isBlog={false}
              title="Boutique de chaussures"
              description="Ce projet est un site e-commerce dédié à la vente de chaussures en ligne. Il inclut des fonctionnalités avancées telles qu'un système de gestion de panier, un processus de paiement sécurisé, et une interface administrateur pour gérer les produits et les commandes. Le site est conçu pour offrir une expérience utilisateur fluide, avec des filtres de recherche avancés et des pages de produits détaillées. Ce projet a été développé pour mettre en pratique les compétences en développement web full-stack, incluant la gestion de bases de données et l'intégration de systèmes de paiement.."
              ghLink="https://github.com/2Alexis/BoutiqueJS"
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={calculatrice}
              isBlog={false}
              title="Calculatrice CSharp."
              description="Cette calculatrice est une application de bureau développée en CSharp utilisant Windows Forms. Elle offre les fonctionnalités de base d'une calculatrice standard, incluant l'addition, la soustraction, la multiplication, et la division. L'interface utilisateur est simple et intuitive, conçue pour être facile à utiliser tout en offrant une expérience utilisateur agréable. Ce projet a été réalisé pour explorer les capacités de développement d'applications de bureau avec CSharp et Windows Forms."
              ghLink="https://github.com/2Alexis/CalculatriceCS"
                           
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={logo}
              isBlog={false}
              title="Littoral Courtage."
              description="Littoral Courtage est un site vitrine développé pour l'entreprise du même nom dans le cadre d'un stage de première année. Le site présente les services offerts par l'entreprise, incluant des informations détaillées sur les produits d'assurance et de courtage. Il comprend également une section de contact pour les clients potentiels, ainsi qu'un espace dédié aux actualités de l'entreprise. Ce projet a été l'occasion de mettre en pratique les compétences en développement web front-end, en créant un site responsive et esthétiquement plaisant.

"
              demoLink="https://littoral-courtage.fr/"
                           
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
